import { createFileRoute, redirect } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { StoreProfitsPage } from "@/modules/profits/pages/StoreProfits.page";

export const Route = createFileRoute("/__authed/m/reports/profits")({
	beforeLoad({ context }) {
		const parsedUser = authUserSchema.safeParse("user" in context ? context.user : undefined);

		if (!parsedUser.success || parsedUser.data.role.slug !== "admin") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: StoreProfitsPage,
});
